export default "__VITE_PUBLIC_ASSET__95860ca5__"